import { render } from "./InfoLocataires.vue?vue&type=template&id=f038112c&scoped=true"
import script from "./InfoLocataires.vue?vue&type=script&lang=js"
export * from "./InfoLocataires.vue?vue&type=script&lang=js"

import "./InfoLocataires.vue?vue&type=style&index=0&id=f038112c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\REAL_ESTATE_DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f038112c"]])

export default __exports__